import * as Atrium from "./Atrium";
import * as OnDemand from "./OnDemand";
import * as Auditorium from "./Auditorium"
import * as ExplorationZone from "./ExplorationZone"
import * as ExibitionHall from "./ExibitionHall"
import { Breakout, Keynote } from "./Breakouts"
import { BoothOne, BoothThree, BoothTwo } from "./Booths";

export default [
    Atrium.body,
    Auditorium.body,
    OnDemand.body,
    Keynote.body,
    Breakout.body,
    ExplorationZone.body,
    ExibitionHall.body,
    BoothThree.body,
    BoothOne.body,
    BoothTwo.body
]